import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

interface ContextMenuProps {
  isOpen: boolean;
  entryRefId: string|null;
  position: { x: number; y: number }|null;
  onClose: () => void;
  onArchiveEntry: (entryRefId: string) => void;
}

const ContextMenu = ({
  isOpen,
  position,
  onClose,
  entryRefId,
  onArchiveEntry,
}: ContextMenuProps) => {
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  if (!isOpen || !position) {
    return null;
  }

  return createPortal(
    <div
      ref={menuRef}
      className="fixed bg-white shadow-lg rounded-lg py-1 min-w-[160px] z-[9999] border border-palette-3"
      style={{
        left: position.x,
        top: position.y,
      }}
    >
      <button
        className="w-full px-4 py-2 text-left hover:bg-palette-1 text-palette-5 text-sm"
        onClick={(e) => {
          e.stopPropagation();
          if (entryRefId) {
            onArchiveEntry(entryRefId);
          }
        }}
      >
      Archive
      </button>
    </div>,
    document.body
  );
};

export default ContextMenu;
